import { render } from "./Column1.vue?vue&type=template&id=254097e1&scoped=true"
import script from "./Column1.vue?vue&type=script&lang=js"
export * from "./Column1.vue?vue&type=script&lang=js"

import "./Column1.vue?vue&type=style&index=0&id=254097e1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-254097e1"]])

export default __exports__